import admin from '@/routes/admin';
import guest from '@/routes/guest';

export default [...admin, ...guest];



// WEBPACK FOOTER //
// ./src/routes/index.js